import Ratings from './Ratings.jsx';
import './Ratings.css';

export default Ratings;
